import {IntermediatePart} from "../../intermediatePart";
import Appliance from "../../parts/appliance";
import {METADATA} from "../../constants";
import Countertop from "../countertop/countertop";
import getHoodConditions from "./getHoodConditions";

export default class DoorHandle extends IntermediatePart {

  constructor(isChild, partNumber = 0) {
    super(isChild);
    this.partNumber = partNumber;
    this.partId = 'door_handle';
    this.partName = 'Door Handle';
    this.canBeDisabled = true;
    this.layerPriority = 2;
    this.translateId = "visualizer.kitchen.cabinet.door_handle";
    this.hasAdditionalParts = true;
    // Door Handle and Drawer Handle are the same as Top Handle and Bottom Handle
    // Top Handle, part 1, size 30, H -->  Door Handle, part 1, size 30, H
    // Top Handle, part 1, size 30, C -->  Door Handle, part 1, size 30, C
    // Top Handle, part 2, size 36     -->  Door Handle, part 2, size 36
    // Top Handle, part 3, size 30     -->  Door Handle, part 3, size 30
    // 9:42
    // Bottom Handle, part 1, size 0, S U    --> Drawer Handle, part 1, size 0, S U /// Placement Bottom
    // --> Door Handle, part 1, size 0, S U /// Placement Bottom
    // 2. Bottom Handle, part 3, size 30           -->  Drawer Handle, part 3, size 30 /// Placement Bottom
    // -->  Door Handle, part 3, size 30 /// Placement Bottom
    // 3. Bottom Handle, part 3, size 30, ST     -->  Drawer Handle, part 3, size 30, ST /// Placement Bottom
    // -->  Door Handle, part 3, size 30, ST /// Placement Bottom
    // 4.  Bottom Handle, part 4, size 36          -->  Drawer Handle, part 4, size 36 /// Placement Bottom
    // -->  Door Handle, part 4, size 36 /// Placement Bottom
    // 5.  Bottom Handle, part 5, size 30, O     -->  Drawer Handle, part 5, size 30, O (edited) /// Placement Bottom
  }

  load(dbFeature) {
    if (((dbFeature.metaData["Part"] && dbFeature.metaData["Part"][0]) === "1") && dbFeature.metaData["Placement"]
      && dbFeature.metaData["Placement"].includes("Bottom")) {
      dbFeature.metaData["Part"] = ["6"];
      // console.log("dbFeaturedbF6", dbFeature);
    } else if (((dbFeature.metaData["Part"] && dbFeature.metaData["Part"][0]) === "3") && dbFeature.metaData["Placement"]
      && dbFeature.metaData["Placement"].includes("Bottom")) {
      dbFeature.metaData["Part"] = ["7"];
      // console.log("dbFeaturedbFeature7", dbFeature);
    }
    if (Array.isArray(dbFeature.metaData["MountType"]) && dbFeature.metaData["MountType"][0] === "0") {
      if (!dbFeature.metaData["MountType"].includes("FM")) {
        dbFeature.metaData["MountType"].push("FM")
      }
      if (!dbFeature.metaData["MountType"].includes("ST")) {
        dbFeature.metaData["MountType"].push("ST")
      }
    }
    if (dbFeature.metaData["RoomLayout"]
      && (dbFeature.metaData["RoomLayout"].includes("Layout3") || dbFeature.metaData["RoomLayout"].includes("3"))) {
      dbFeature.metaData["MountType"] = METADATA.ALL
    }
    if (dbFeature.metaData["RoomLayout"]
      && (dbFeature.metaData["RoomLayout"].includes("Layout6") || dbFeature.metaData["RoomLayout"].includes("6"))) {
      if (!dbFeature.metaData["Stovetop"]) {
        dbFeature.metaData["Stovetop"] = METADATA.NO
      }
    }
    const partNumber = (dbFeature.metaData["Part"] && dbFeature.metaData["Part"][0]) === "1" ? 1 : 2;
    return super.load_(dbFeature, new DoorHandle(false, partNumber), true, partNumber === 1 ? 'features' : 'featuresParts');
  }

  getArrayOfConditions() {
    const conditions = super.getArrayOfConditions();
    return [...conditions, ...getHoodConditions(this.getParent())]
  }

  getActiveFeatureConditions() {
    return this.getArrayOfConditions().filter(metaObject => {
      return metaObject.propName !== "Hood" && metaObject.propName !== "Width" && metaObject.propName !== "HoodHeight"
    })
  }

  getActiveFeaturePartsAccordingToActiveFeature(fromFeature = this.activeFeature, activeFeatureConditions = []) {
    let activeFeatureParts = [];
    if (fromFeature && fromFeature.partNumber) {
      const name1 = fromFeature.getSplittedFeatureName();
      // console.log("name1", name1);
      let arrayOfConditions = activeFeatureConditions.length
        ? activeFeatureConditions
        : this.getActiveFeatureConditions(fromFeature);

      const cabinetParent = this.getParent();
      const applianceParent = cabinetParent.layout.parts[Appliance.id];
      const countertopParent = cabinetParent.layout.parts[Countertop.id];

      //part 1 will be with MountType
      // part 2 dishwasher - depends on dishwasher metaData Width
      //part 3 depends on stove metaData Width // on Room Layout 6 we have Range + Stovetop, not Stove
      // part 4 - fridge
      // part 5 - peninsula

      let withStoveConditions = [...arrayOfConditions];
      if (applianceParent && applianceParent.layout.type === 6) {
        const rangeIsActive = applianceParent && applianceParent.range && !applianceParent.range.disabled && applianceParent.range.activeFeature;
        withStoveConditions.push({
          propName: "Stovetop",
          propValue: rangeIsActive ? METADATA.NO : "ST",
        });
        if (rangeIsActive && applianceParent.range.activeFeature.metaData["Width"]) {
          withStoveConditions.push({
            propName: "Width",
            propValue: applianceParent.range.activeFeature.metaData["Width"],
          })
        }
      } else {
        withStoveConditions.push({
          propName: "Width",
          propValue: applianceParent && applianceParent.stove && applianceParent.stove.activeFeature
          && applianceParent.stove.activeFeature.metaData["Width"]
            ? applianceParent.stove.activeFeature.metaData["Width"]
            : "30",
        })
      }
      const withFridgeConditions = [...arrayOfConditions, {
        propName: "Width",
        propValue: applianceParent && applianceParent.fridge && applianceParent.fridge.activeFeature
        && applianceParent.fridge.activeFeature.metaData["Width"]
          ? applianceParent.fridge.activeFeature.metaData["Width"]
          : "36",
      }];
      activeFeatureParts = this.featuresParts.filter((feature) => {
        if (name1 !== feature.getSplittedFeatureName()) {
          return false
        }
        if (feature.metaData["Part"] && feature.metaData["Part"].includes("2")) {
          const fridgeIsVisible = applianceParent && applianceParent.fridge && !applianceParent.fridge.disabled
            && applianceParent.fridge.activeFeature;
          const fridgeConditions = applianceParent && applianceParent.fridge
            ? applianceParent.fridge.getFridgeWidthAndHeightConditions()
            : [];
          return feature.matchesMetaForArrayOfConditions([
            ...arrayOfConditions, {
              propName: "Fridge",
              propValue: fridgeIsVisible ? "F" : "C"
            }, ...fridgeConditions
          ])
        } else if (feature.metaData["Part"] && feature.metaData["Part"].includes("3")) {
          if (!applianceParent || !applianceParent.oven || applianceParent.oven.disabled || !applianceParent.oven.activeFeature) {
            return false
          }
          return feature.matchesMetaForArrayOfConditions(arrayOfConditions)
        }
        if (feature.metaData["Part"] && feature.metaData["Part"].includes("4")) {
          return feature.matchesMetaForArrayOfConditions(withFridgeConditions)
        }
        if (feature.metaData["Part"] && feature.metaData["Part"].includes("5")) {
          if (!applianceParent || !applianceParent.oven || applianceParent.oven.disabled || !applianceParent.oven.activeFeature) {
            return false
          }
        }
        if (feature.metaData["Part"] && feature.metaData["Part"].includes("6")) {
          if (countertopParent && countertopParent.sink && countertopParent.sink.activeFeature && !countertopParent.sink.disabled) {
            return feature.matchesMetaForArrayOfConditions([
              ...arrayOfConditions, {
                propName: "MountType",
                propValue: countertopParent.sink.activeFeature.metaData["MountType"]
              }])
          }
        }
        if (feature.metaData["Part"] && feature.metaData["Part"].includes("7")) {
          return feature.matchesMetaForArrayOfConditions(withStoveConditions)
        }
        return feature.matchesMetaForArrayOfConditions(arrayOfConditions)
      });

      // console.log("this.featuresParts", this.featuresParts);
      // console.log("activeFeatureParts", activeFeatureParts);
      activeFeatureParts.forEach((activeFeaturePart) => {
        activeFeaturePart.disabled = this.disabled
      });
    }
    return activeFeatureParts
  }
}
